import React, { PureComponent } from 'react';
import {
  Button,
  FontIcon,
  DialogContainer,
  Grid,
  Cell,
  Snackbar,
} from 'react-md';
import { trackEvent } from '../../util/analytics';
import '../AlertSignupCard/AlertSignupCard.scss';

class TrendReportModal extends PureComponent {
  state = { visible: false, toasts: [] };

  addToast = (text, action, autohide = true) => {
    this.setState((state) => {
      const toasts = state.toasts.slice();
      toasts.push({ text, action });
      return { toasts, autohide };
    });
  };

  toastConfirmation = () => {
    this.addToast('Thank you for signing up. We will be in touch shortly.');
    this.setState({ visible: false });
    window.open(
      '//bit.ly/2EdPSf2',
      '_blank',
      'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,width=700,height=480',
      '',
    );
    trackEvent({
      category: 'Alert Signup',
      action: 'Signup',
      label: this.props.title,
    });
  };

  dismissToast = () => {
    const [, ...toasts] = this.state.toasts;
    this.setState({ toasts });
  };

  show = () => {
    this.setState({ visible: true });
    trackEvent({
      category: 'Alert Signup',
      action: 'Click',
      label: this.props.title,
    });
  };

  hide = () => {
    this.setState({ visible: false });
    window.open(
      '//bit.ly/2uFJDRF',
      '_blank',
      'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,width=700,height=480',
      '',
    );
    trackEvent({
      category: 'Alert Signup',
      action: 'No Thanks',
      label: this.props.title,
    });
  };

  render() {
    const { visible, toasts } = this.state;

    const actions = [
      {
        onClick: this.toastConfirmation,
        primary: true,
        children: 'Sign up',
      },
      {
        onClick: this.hide,
        primary: true,
        children: 'No thanks',
      },
    ];

    return (
      <div>
        <Button onClick={this.show} icon style={{ color: '#385A9A' }}>
          add_alert
        </Button>
        <DialogContainer
          portal
          id="signup-alert-modal"
          visible={visible}
          title="Enable Critical Alerts"
          onHide={this.hide}
          aria-describedby="signup-alert-description"
          modal
          actions={actions}
        >
          <Grid className="dialog-outer">
            <Cell size={6} style={{ backgroundColor: '#EFF4FC' }}>
              <p className="alerts-tier-title" style={{ fontWeight: 700 }}>
                &nbsp;&nbsp;Critical Alerts
              </p>
              <Grid className="dialog-inner">
                <Cell size={1} className="icon-wrapper">
                  <FontIcon className="icon-proper">timelapse</FontIcon>
                </Cell>
                <Cell size={11}>
                  <h2 className="alert-item-text">
                    Prevent irreversible downtime due to SSL pinning mistakes
                  </h2>
                </Cell>

                <Cell size={1} className="icon-wrapper">
                  <FontIcon className="icon-proper">bug_report</FontIcon>
                </Cell>
                <Cell size={11}>
                  <h2 className="alert-item-text">
                    Detect malicious domains forging your SSL certificates
                  </h2>
                </Cell>

                <Cell size={1} className="icon-wrapper">
                  <FontIcon className="icon-proper">healing</FontIcon>
                </Cell>
                <Cell size={11}>
                  <h2 className="alert-item-text">
                    Avoid embarrassment due to expired SSL certificates
                  </h2>
                </Cell>
              </Grid>
            </Cell>
            <Cell size={6}>
              <p className="alerts-tier-title">&nbsp;&nbsp;Scheduled Reports</p>
              <Grid className="dialog-inner">
                <Cell size={1} className="icon-wrapper">
                  <FontIcon className="icon-proper">trending_up</FontIcon>
                </Cell>
                <Cell size={11}>
                  <h2 className="alert-item-text">
                    Discover trends in eavesdropping attempts across your user
                    base
                  </h2>
                </Cell>

                <Cell size={1} className="icon-wrapper">
                  <FontIcon className="icon-proper">description</FontIcon>
                </Cell>
                <Cell size={11}>
                  <h2 className="alert-item-text">
                    Details of eavesdropping attempts on encrypted user sessions
                  </h2>
                </Cell>

                <Cell size={1} className="icon-wrapper">
                  <FontIcon className="icon-proper">https</FontIcon>
                </Cell>
                <Cell size={11}>
                  <h2 className="alert-item-text">
                    Set policies to detect violations of user privacy and
                    compliance
                  </h2>
                </Cell>
              </Grid>
            </Cell>
          </Grid>
        </DialogContainer>

        <Snackbar
          id="alertsignup-snackbar"
          toasts={toasts}
          autohide
          onDismiss={this.dismissToast}
        />
      </div>
    );
  }
}

export default TrendReportModal;



// WEBPACK FOOTER //
// ./src/components/TrendReportModal/TrendReportModal.jsx